(function(){
  // menu mobile
  var t=document.querySelector('.hd-toggle'),n=document.getElementById('hd-nav');
  if(t&&n){t.addEventListener('click',function(){var o=n.classList.toggle('aperto');t.setAttribute('aria-expanded',o)});
    n.addEventListener('click',function(e){if(e.target.tagName==='A'){n.classList.remove('aperto');t.setAttribute('aria-expanded','false')}})}
  // filtri linee
  document.querySelectorAll('.filtri').forEach(function(g){
    var lista=g.parentElement.querySelectorAll('.linea');
    g.addEventListener('click',function(e){
      var b=e.target.closest('.filtro');if(!b)return;
      g.querySelectorAll('.filtro').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
      var f=b.dataset.filtro;
      lista.forEach(function(li){li.hidden=!(f==='tutte'||li.dataset.divisione===f)});
    });
  });
  // dopo l'invio del form porta il salone alla conferma
  var es=document.querySelector('.esito, .errore');
  if(es){var s=es.closest('section');if(s){s.scrollIntoView();es.focus&&es.focus()}}
})();
